// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/assignments.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { AccountStub } from "./common_pb.ts";
import { PlatformFeeSchedule } from "./billing_pb.ts";

/**
 * @generated from message protogen.AssignmentRequest
 */
export class AssignmentRequest extends Message<AssignmentRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string status = 2;
   */
  status = "";

  /**
   * @generated from field: int32 rank = 3;
   */
  rank = 0;

  /**
   * @generated from field: protogen.AccountStub advisor = 4;
   */
  advisor?: AccountStub;

  /**
   * @generated from field: protogen.AccountStub creator = 5;
   */
  creator?: AccountStub;

  /**
   * @generated from field: int64 expiresAtSec = 6;
   */
  expiresAtSec = protoInt64.zero;

  /**
   * @generated from field: string declinedReason = 7;
   */
  declinedReason = "";

  constructor(data?: PartialMessage<AssignmentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AssignmentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "rank", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "advisor", kind: "message", T: AccountStub },
    { no: 5, name: "creator", kind: "message", T: AccountStub },
    { no: 6, name: "expiresAtSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "declinedReason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssignmentRequest {
    return new AssignmentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssignmentRequest {
    return new AssignmentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssignmentRequest {
    return new AssignmentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AssignmentRequest | PlainMessage<AssignmentRequest> | undefined, b: AssignmentRequest | PlainMessage<AssignmentRequest> | undefined): boolean {
    return proto3.util.equals(AssignmentRequest, a, b);
  }
}

/**
 * @generated from message protogen.AssignmentOpportunity
 */
export class AssignmentOpportunity extends Message<AssignmentOpportunity> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * Ref to the signup that created this assignment request.
   *
   * @generated from field: string signupRef = 2;
   */
  signupRef = "";

  /**
   * Ref to the family that created this assignment request.
   *
   * @generated from field: string familyRef = 3;
   */
  familyRef = "";

  /**
   * Name of the family that created this assignment request.
   *
   * @generated from field: string familyName = 4;
   */
  familyName = "";

  /**
   * @generated from field: string state = 5;
   */
  state = "";

  /**
   * @generated from field: string location = 6;
   */
  location = "";

  /**
   * @generated from field: string description = 7;
   */
  description = "";

  /**
   * @generated from field: int32 monthlyRateCents = 8;
   */
  monthlyRateCents = 0;

  /**
   * @generated from field: float monthlyHours = 9;
   */
  monthlyHours = 0;

  /**
   * @generated from field: int64 expiresAtSec = 10;
   */
  expiresAtSec = protoInt64.zero;

  /**
   * @generated from field: string approximateDistanceMiles = 11;
   */
  approximateDistanceMiles = "";

  /**
   * @generated from field: bool isPayAsYouGo = 12;
   */
  isPayAsYouGo = false;

  /**
   * @generated from field: string declinedReason = 13;
   */
  declinedReason = "";

  /**
   * @generated from field: protogen.PlatformFeeSchedule platformFeeSchedule = 14;
   */
  platformFeeSchedule = PlatformFeeSchedule.SCHEDULE_NOT_SET;

  /**
   * Entity type: "signup_submission" or "rematch_session"
   *
   * @generated from field: string entityType = 15;
   */
  entityType = "";

  /**
   * @generated from field: bool immediateRematch = 16;
   */
  immediateRematch = false;

  /**
   * @generated from field: int64 expectedStartAtSec = 17;
   */
  expectedStartAtSec = protoInt64.zero;

  constructor(data?: PartialMessage<AssignmentOpportunity>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AssignmentOpportunity";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "signupRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "familyName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "monthlyRateCents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "monthlyHours", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "expiresAtSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "approximateDistanceMiles", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "isPayAsYouGo", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "declinedReason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "platformFeeSchedule", kind: "enum", T: proto3.getEnumType(PlatformFeeSchedule) },
    { no: 15, name: "entityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "immediateRematch", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "expectedStartAtSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssignmentOpportunity {
    return new AssignmentOpportunity().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssignmentOpportunity {
    return new AssignmentOpportunity().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssignmentOpportunity {
    return new AssignmentOpportunity().fromJsonString(jsonString, options);
  }

  static equals(a: AssignmentOpportunity | PlainMessage<AssignmentOpportunity> | undefined, b: AssignmentOpportunity | PlainMessage<AssignmentOpportunity> | undefined): boolean {
    return proto3.util.equals(AssignmentOpportunity, a, b);
  }
}

